export default "__VITE_ASSET__BkyZ5dSo__"